module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_6005.17e43ded.png";